<template>
  <div>
    <v-row>
      <v-container>
      <v-col>
        <v-row>
          <div v-for="Tclass in person.classes" :key="Tclass.id">
            <v-col>
              <class_card v-bind:Tclass="Tclass"/>
            </v-col>
          </div>
        </v-row>
      </v-col>
      </v-container>
    </v-row>
  </div>
</template>


<script>
  import class_card from '@/components/class_card.vue';

  export default {
    name: 'App',

    components: {
      class_card,
    },

    data(){
      return{
        person:{
          firstName: 'Sam',
          lastName: 'Riggs',
          email: 'SamIsRiggs@coolBeanz.coolio',
          classes:[{
            title: 'Fun Animal Bio 2nd Period',
            image: 'subjects_img/Biology.jpg',
            description: 'test',
          },{
            title: 'Chemistry',
            image: 'subjects_img/Chemistry.jpg',
            description: 'test',
          },{
            title: 'Computer Science',
            image: 'subjects_img/Computer Science.jpg',
            description: 'test',
          },{
            title: 'English',
            image: 'subjects_img/English.jpg',
            description: 'test',
          },{
            title: 'Mathematics',
            image: 'subjects_img/Mathematics.jpg',
            description: 'test',
          },{
            title: 'Physics',
            image: 'subjects_img/Physics.jpg',
            description: 'test',
          },],
        },


      }
    }
  };
</script>
